import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import PageRoutes from './pages/PageRoutes';

const queryClient = new QueryClient({
    defaultConfig: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export default class DiscoverApp extends React.Component {
    render() {
        return (
            <QueryClientProvider client={queryClient}>
                <PageRoutes {...this.props} />
            </QueryClientProvider>
        );
    }
}
